module.exports = __webpack_public_path__ + "img/loading-dot-icon.360f2e7f.gif";